import { getIndexById } from '../util/paginate'

// initial state
const state = {
  selectedItem: null, // 选中的收货地址
  editingItem: null, // 当前正在编辑的收货地址（避免 query 传对象）
  items: [],
}

// 遍历获取默认item
const getDefaultItem = (items) => {
  let item = null
  for (let i = 0; i < items.length; i++) {
    const element = items[i];
    if (element.is_default) {
      item = element
      break
    }
  }
  return item
}

// mutations
const mutations = {
  setDefaultAddress(state, item) {
    // 当前选中的地址和要设置为默认的地址不同时，更新当前选中的地址值
    let selectedItem = state.selectedItem
    if (selectedItem && selectedItem.id) {
      if (selectedItem.id !== item.id) {
        selectedItem.is_default = false
      } else {
        selectedItem.is_default = true
      }
      this.commit('selectAddressItem', selectedItem)
    }
  },
  selectAddressItem(state, item) {
    state.selectedItem = item
  },
  unselectAddressItem(state) {
    state.selectedItem = null
  },
  setEditingAddress(state, item) {
    state.editingItem = item || null
  },
  clearEditingAddress(state) {
    state.editingItem = null
  },
  traverseAddressItems(state) {
    const { items } = state
    if (items && items.length) {
      let defaultItem = getDefaultItem(items)
      if (defaultItem) {
        this.commit('setDefaultAddress', defaultItem)
      }

      if (state.selectedItem === null || state.selectedItem === undefined) {
        let item = defaultItem ? defaultItem : items[0]
        this.commit('selectAddressItem', item)
      }
    }
  },
  addAddressItem(state, item) {
    state.items.push(item)
    this.commit('traverseAddressItems')
  },
  removeAddressItem(state, id) {
    const { items } = state
    let index = getIndexById(items, id)
    state.items.splice(index, 1)

    // 当前选中的地址和要删除的地址相同时，当前选中的地址置为空
    let selectedItem = state.selectedItem
    if (selectedItem && selectedItem.id && selectedItem.id === id) {
      this.commit('unselectAddressItem')
    }
    this.commit('traverseAddressItems')
  },
  modifyAddressItem(state, item) {
    const { items } = state
    let index = getIndexById(items, item.id)
    state.items.splice(index, 1, item)

    // 当前选中的地址和要修改的地址相同时，更新当前选中的地址
    let selectedItem = state.selectedItem
    if (selectedItem && selectedItem.id && selectedItem.id === item.id) {
      this.commit('selectAddressItem', item)
    }
    this.commit('traverseAddressItems')
  },
  saveAddressItems(state, items) {
    state.items = items
    this.commit('traverseAddressItems')
  },
}

export default {
  state,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/address.js